import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { Consulta } from 'src/app/models/consulta';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { forkJoin, of } from 'rxjs';
import { distinctUntilChanged, debounceTime, first } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { CiacService } from 'src/app/services/http/ciac.service';

@Component({
  selector: 'app-form-config-laudo-union',
  templateUrl: './form-config-laudo-union.component.html',
  styleUrls: ['./form-config-laudo-union.component.scss']
})
export class FormConfigLaudoUnionComponent implements OnInit {

  listaClientes = [{ id: null, nomefantasia: 'Selecione' }, { id: 0, nomefantasia: 'AVULSO' }];
  listaTipoVistoria = [{ id: '', nome: 'Selecione' }];
  listaConsultas: Consulta[] = [];
  listaCreditos: Consulta[] = [];
  listaConsultaEspecial: Consulta[] = [];
  auditoria: any;
  combinado: any;
  textObrigatoriedade = true;

  config;
  textoPadrao: string = '';
  nomenclatura = '1';
  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    cliente: new FormControl('', [Validators.required]),
    tipoVistoria: new FormControl('', [Validators.required])
  });
  id: any;
  uuid: any;
  permissaoAuditoria: any;
  listaConfigExemplo: any = [];
  exemploVistoria = new FormControl('');

  creditos = [];
  veiculos = [];

  constructor(
    private consultaService: ConsultaService,
    private laudoService: LaudoUnionService,
    private activedRoute: ActivatedRoute,
    private router: Router,
    private msgService: ModalMsgService,
    private loginService: LoginService,
    private ciacService: CiacService
  ) { }


  ngOnInit() {
    this.loginService.getLogIn().pipe(first()).subscribe((user) => {
      if (user) {
        let permissoes = user.permissoes;
        // this.permissaoAuditoria = (permissoes.administrador || permissoes.auditoria_associarunidades || permissoes.auditoria_configlaudo);
        this.permissaoAuditoria = permissoes.config_auditoria;
      }
    });

    this.uuid = this.activedRoute.snapshot.paramMap.get('uuid');
    if (this.uuid) {
      // Busca o registro da configuração de laudo através do UUID
      this.laudoService.getConfigLaudo(this.uuid).then(lc => {
        // Verifica se retornou o registro
        if(lc) {
          // Busca a lista das configurações de laudo já salva através do ID do Tipo Laudo
          this.laudoService.getListaCopyConfigLaudo(lc['idTipoLaudo']).then( lista => {
            // Envia retorno para função
            this.getListaConfigLaudo(lista)
          });
        }
      });
      this.getListaConsultas().then(() => this.getConfig());
      this.form.removeControl('cliente');
      this.form.removeControl('tipoVistoria');
    } else {
      this.getListas();
    }

    this.exemploVistoria.valueChanges.subscribe(r => this.getConfig(r));

    this.auditoria = {
      nome: 'Enviar laudo para auditoria',
      value: false,
      checked: false
    }
    this.combinado = {
      nome: 'Laudo combinado',
      value: false,
      checked: false
    }
  }

  getListaConfigLaudo(lista) {
    this.listaConfigExemplo = lista;
  }


  async getListas() {
    let r = await forkJoin({
      listaConsultas: this.consultaService.listaConsulta(),
      // listaCreditos: this.ciacService.getConsultaCreditoLaudo(),
      listaConsultaEspecial: this.consultaService.listaConsultaDecisaoCerta(),
      listaClientes: this.laudoService.getListaClienteUnidade(),
      listaTipoVistoria: this.laudoService.getListaTipoLaudo(),
      listaConfigExemplo: this.laudoService.getListaConfigLaudo({ page: 1, per_page: 100000, sorting: { nome: "desc", descricao: '' } })
    }).toPromise();
    // this.listaConsultas = [...r.listaConsultas, ...r.listaCreditos];
    this.listaConsultas = [...r.listaConsultas];
    this.listaConsultaEspecial = r.listaConsultaEspecial;
    this.listaClientes = [...this.listaClientes, ...r.listaClientes];
    this.listaTipoVistoria = [...this.listaTipoVistoria, ...r.listaTipoVistoria];
    this.listaConfigExemplo = r.listaConfigExemplo.lista;
    this.separaTipoConsulta();
    document.getElementById("btnM").click();
  }

  async getListaConsultas() {
    let r = await forkJoin({
      listaConsultas: this.consultaService.listaConsulta(),
      // listaCreditos: this.ciacService.getConsultaCreditoLaudo(),
      listaConsultaEspecial: this.consultaService.listaConsultaDecisaoCerta(),
    }).toPromise();
    // this.listaConsultas = [...r.listaConsultas, ...r.listaCreditos];
    this.listaConsultas = [...r.listaConsultas];
    this.listaConsultaEspecial = r.listaConsultaEspecial;
    this.separaTipoConsulta();
  }

  async getConfig(uuid = null) {
    this.config = await this.laudoService.getConfigLaudo(uuid || this.uuid);

    this.auditoria.checked = this.config.auditoria;
    this.auditoria.value = this.config.auditoria;

    this.combinado.checked = this.config.combinado;
    this.combinado.value = this.config.combinado;
    this.form.get('nome').patchValue(this.config.nome);
    this.textoPadrao = this.config.textoPadrao;

    if (this.config.nomenclaturaParecer1)
      this.nomenclatura = '1';
    else if (this.config.nomenclaturaParecer2)
      this.nomenclatura = '2';
    else if (this.config.nomenclaturaParecer3)
      this.nomenclatura = '3';
    else if (this.config.nomenclaturaParecer4)
      this.nomenclatura = '4';

    // Limpa os checks antes de setar a configuração do laudo
    if (this.config) {
      this.listaConsultas.forEach(c => {
        c.checked = false
      });
      this.listaConsultaEspecial.forEach(c => {
        c.checked = false
      });
    }

    if (this.config.consultas) {
      // Marca todos os checks como false e habilitados
      this.listaConsultas.forEach(c => { c.checked = false, c.disabled = false });
      // Verifica se a quantidade de consultas da config é maior que zero
      if (this.config.consultas.length > 0) {
        // Se satisfazer condição, entra no if e marca todos checks conforme a consulta vinda do bd, deixando o disable como false
        this.config.consultas.forEach(c => {
          this.listaConsultas.filter(c2 => c2.tipoConsulta == c).forEach(c2 => { c2.checked = true, c2.disabled = false });
        });
      }
      // Caso contrário, os checkts fica como desmarcado e disable como ativo (Para as consultas avulsas);
    } else {
      this.listaConsultas.forEach(c => { c.checked = false, c.disabled = true });
    }

    if (this.config.consultasEspeciais) {
      // Marca todos os checks como false e habilitados
      this.listaConsultaEspecial.forEach(c => { c.checked = false, c.disabled = true });
      // Verifica se a quantidade de consultas da config é maior que zero
      if (this.config.consultasEspeciais.length > 0) {
        // Se satisfazer condição, entra no if e marca todos checks conforme a consulta vinda do bd, deixando o disable como false
        this.config.consultasEspeciais.forEach(c => {
          this.listaConsultaEspecial.filter(c2 => c2.nome == c).forEach(c2 => { c2.checked = true, c2.disabled = false });
        });
      }
      // Caso contrário, os checkts fica como desmarcado e disable como ativo (Para as consultas especiais);
    } else {
      this.listaConsultaEspecial.forEach(c => { c.checked = false, c.disabled = true });
    }

    this.setMensagemConsultas();
  }

  separaTipoConsulta() {
    for (let i = 0; i < this.listaConsultas.length; i++) {
      const e = this.listaConsultas[i];
      if (
        e.tipoConsulta == "RELATORIO_UNIFICADO_PF" ||
        e.tipoConsulta == "RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF" ||
        e.tipoConsulta == "RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ" ||
        e.tipoConsulta == "RELATORIO_UNIFICADO_PJ" ||
        e.tipoConsulta == 'RELATORIO_SINTETICO_PLUS_SCORE_PJ' ||
        e.tipoConsulta == 'RELATORIO_SINTETICO_PLUS_SCORE_PF'
      ) {
        this.creditos.push(e);
      }

      if (
        e.tipoConsulta != "RELATORIO_UNIFICADO_PF" &&
        e.tipoConsulta != "RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF" &&
        e.tipoConsulta != "RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ" &&
        e.tipoConsulta != "RELATORIO_UNIFICADO_PJ" &&
        e.tipoConsulta != 'RELATORIO_SINTETICO_PLUS_SCORE_PJ' &&
        e.tipoConsulta != 'RELATORIO_SINTETICO_PLUS_SCORE_PF'
      ) {
        this.veiculos.push(e);
      }
    }
  }


  novoConfigLaudo() {
    this.laudoService.getConfigTipoLaudo(this.form.value.tipoVistoria.id).then(
      r => this.config = r
    );
  }

  selecionarConsulta(event) {
    this.listaConsultaEspecial.forEach(c => {
      if (event) {
        c.checked = false;
        c.disabled = true;
      } else {
        c.checked = false;
        c.disabled = false;
      }
    });
    this.setMensagemConsultas();
  }

  selecionarConsultaEspecial(event) {
    this.listaConsultas.forEach(c => {
      if (event) {
        c.checked = false;
        c.disabled = true;
      } else {
        c.checked = false;
        c.disabled = false;
      }
    });

    if (event) {
      this.listaConsultaEspecial.filter(c => !c.checked).map(c => c.disabled = true);
    } else {
      this.listaConsultaEspecial.map(c => {
        c.disabled = false;
        c.checked = false;
      })
    }

    this.setMensagemConsultas();
  }

  selecionarAuditoria(event) {

    if (!this.uuid) {
      this.auditoria.value = true;
    }

    if (this.uuid) {
      if (event && this.auditoria.checked == false && this.auditoria.value == false) {
        this.auditoria.checked = true;
        this.auditoria.value = true;
      } else if (event && this.auditoria.checked == true && this.auditoria.value == true) {
        this.auditoria.checked = true;
        this.auditoria.value = true;
      } else {
        this.auditoria.checked = false;
        this.auditoria.value = false;
      }
    }
  }

  selecionarCombinado(event) {

    if (!this.uuid) {
      this.combinado.value = true;
    }

    if (this.uuid) {
      if (event && this.combinado.checked == false && this.combinado.value == false) {
        this.combinado.checked = true;
        this.combinado.value = true;
      } else if (event && this.combinado.checked == true && this.combinado.value == true) {
        this.combinado.checked = true;
        this.combinado.value = true;
      } else {
        this.combinado.checked = false;
        this.combinado.value = false;
      }
    }
  }

  selecionarVisivel(event, field, group) {
    if (field.type == 0) {
      group.fields.forEach(f => {
        f.visivel = event;

        if (f.img) {
          f.img.visivel = event;
        }

        if (!event) {
          f.obrigatorio = false;
          f.imprimir = false;

          if (f.img) {
            f.img.obrigatorio = false;
            f.img.imprimir = false;
          }
        }
      });
    }

    if (!event) {
      field.obrigatorio = false;
      field.imprimir = false;

      if (field.img) {
        field.img.obrigatorio = false;
        field.img.imprimir = false;
        field.img.visivel = false;
      }
    }
  }

  selecionarObrigatorio(event, field, group) {
    if (field.type == 0) {
      group.fields.forEach(f => {
        if (f.visivel) {
          f.obrigatorio = event;
          if (f.img && f.img.visivel) {
            f.img.obrigatorio = event;
          }
        }
      });
    }
  }

  selecionarImprimir(event, field, group) {
    if (field.type == 0) {
      group.fields.forEach(f => {
        if (f.visivel) {
          f.imprimir = event;
          if (f.img && f.img.visivel) {
            f.img.imprimir = event;
          }
        }
      });
    }
  }

  setMensagemConsultas() {
    let consultas = this.listaConsultas.concat(this.listaConsultaEspecial);
    this.textObrigatoriedade = (consultas.filter(c => c.checked).length == 0);
  }



  async salvar() {

    let config = {
      auditoria: this.auditoria.value,
      combinado: this.combinado.value,
      acoes: [],
      consultas: this.listaConsultas.filter(c => c.checked),
      consultasEspeciais: this.listaConsultaEspecial.filter(c => c.checked),
      cliente: null,
      tipoVst: null,
      nomeConfigTipoLaudo: this.form.value.nome,
      nomenclaturaParecer1: this.nomenclatura == '1',
      nomenclaturaParecer2: this.nomenclatura == '2',
      nomenclaturaParecer3: this.nomenclatura == '3',
      nomenclaturaParecer4: this.nomenclatura == '4',
      preencherPositivos: false,
      textoPadrao: this.textoPadrao
    };

    this.config.groups.forEach(g => g.fields.forEach(f => config.acoes.push(f)));

    if (!this.uuid) {
      let cliente = this.form.controls.cliente.value;
      config.cliente = { value: cliente.id, label: cliente.nomefantasia, permission: true };

      let tipoVst = this.form.controls.tipoVistoria.value;
      config.tipoVst = { value: tipoVst.id, label: tipoVst.nome, permission: true };
    }

    // Verifica antes se as consultas marcadas é maior que 0 tanto para adição quanto para edição ...
    if (config.consultas.filter(c => c.checked).length == 0 && config.consultasEspeciais.filter(ce => ce.checked).length == 0 || this.form.invalid) {
      this.msgService.openDialog('Erro ao efetuar operação', 'Não foi possível salvar configuração, por favor verifique todos os campos', 'danger');
      return;
    }

    try {
      if (this.uuid) {
        await this.laudoService.editarConfigLaudo(this.uuid, config);
      } else {
        await this.laudoService.salvarConfigLaudo(config);
      }
    } catch (error) {
      this.msgService.openDialog('Erro ao efetuar operação', 'Não foi possivel salvar a configuração de laudo', 'danger');
      return;
    }

    try {
      this.msgService.openDialog('Configuração salva com sucesso');
    } catch (error) { } finally {
      this.router.navigate(['laudo', 'configuracao', 'listar']);
    }

  }

}
